// import Writs from './';

export default {
  priority: 93,
  name: app.translate('routes.home.attendance.stack.Packs'),
  path: 'packs',
  permissions: ['StackRulesMenu'],
  icon: 'alarm-snooze',
  drawer: true,
};


